var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading-container"}},[_c('b-spinner',{attrs:{"label":"Loading...","variant":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }